/* rm-cart-build.js. Linked removal for build groups in the cart
   (snippets/cart-products.liquid marks each row with data-rm-build="<Build id>").

   Lines that share a "Build id" line property are one build: the custom builder's
   wheelset and its finish upcharge lines, or a Ready-to-Ride wheelset and its tire
   choice line. Removing any line of a group removes every line of that group in one
   /cart/update.js call, so a charge line can never be left without its wheelset and a
   wheelset never loses the charge for the finish or tires written on it.

   The theme's remove buttons are handled by component.js through a capturing listener
   on document, so this one listens on window in the capture phase, which runs first,
   and only steps in when the row belongs to a group of two or more lines. A line
   with no Build id, or a build that is a single line, goes through the theme exactly
   as before. The cart sections are re-rendered by the theme itself: the update is
   announced as a CartLinesUpdateEvent from outside cart-items-component, which makes
   every cart-items-component on the page morph to the sections in the response. */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__rmCartBuild) {
  window.__rmCartBuild = true;

  const rowsOf = (scope, id) =>
    Array.from(scope.querySelectorAll('tr[data-rm-build]')).filter((r) => r.dataset.rmBuild === id);

  window.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const btn = target?.closest('.cart-items__remove');
      if (!btn) return;
      const row = btn.closest('tr[data-rm-build]');
      const id = row?.dataset.rmBuild;
      if (!id) return;
      const component = row.closest('cart-items-component') || document;
      const group = rowsOf(component, id);
      if (group.length < 2) return;

      event.preventDefault();
      event.stopPropagation();
      if (component.classList?.contains('cart-items-disabled')) return;

      const updates = {};
      group.forEach((r) => {
        if (r.dataset.key) updates[r.dataset.key] = 0;
      });

      const sections = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
        if (el instanceof HTMLElement && el.dataset.sectionId && !sections.includes(el.dataset.sectionId)) {
          sections.push(el.dataset.sectionId);
        }
      });

      component.classList?.add('cart-items-disabled');
      group.forEach((r) => r.classList.add('rm-build-removing'));

      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'remove',
          context: 'cart',
          lines: Object.keys(updates).map((key) => ({ id: key, quantity: 0 })),
          promise: deferred.promise,
        })
      );

      fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: sections.join(','), sections_url: window.location.pathname }),
      })
        .then((r) => r.json().then((json) => ({ ok: r.ok, json })))
        .then(({ ok, json }) => {
          if (!ok || !json || json.status || json.errors || json.description) {
            throw new Error((json && (json.description || json.errors || json.message)) || 'Cart update failed');
          }
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(json),
            detail: {
              sections: json.sections,
              items: json.items,
              itemCount: json.item_count,
              source: 'rm-cart-build',
              didError: false,
            },
          });
        })
        .catch((err) => {
          deferred.reject(err);
          group.forEach((r) => r.classList.remove('rm-build-removing'));
        })
        .finally(() => {
          component.classList?.remove('cart-items-disabled');
        });
    },
    true
  );
}
